import React from "react";
import AssigneeDropdown from "../../pages/weekly-wins/AssigneeDropdown";

export default function AssigneeComponent({ item, onDataChange, index, dKey }) {
  const handleAssignUser = user => {
    onDataChange(index, user, dKey);
  };
  return (
    <div className="pl-2">
      <AssigneeDropdown
        editTask={() => {}}
        assignedUserFormat={handleAssignUser}
        task={{ assignedTo: item[dKey] }}
        noMargin
        removeUser={() => handleAssignUser(null)}
        helpText={"Select user"}
      />
    </div>
  );
}
